import { type CloudFlowNodeType } from "@doitintl/cmp-models";
import ForkRightRoundedIcon from "@mui/icons-material/ForkRightRounded";
import { Card, Stack } from "@mui/material";
import { useTheme } from "@mui/system";

import { cloudflowTexts } from "../../../../../assets/texts";
import ConditionForm from "../../FilterAction/ConditionForm";
import FieldReferenceForm from "../../FilterAction/FieldReferenceForm";
import SwitchDataSourceDialog from "../../FilterAction/SwitchDataSourceDialog";
import { useNodeDataSourceUpdate } from "../hooks";
import { useNodeConfigurationContext } from "../NodeConfigurationContext";
import { NodeCardHeader } from "./NodeCardHeader";

export const ConditionParametersTab = () => {
  const {
    palette: { primary },
  } = useTheme();

  const { nodeConfig } = useNodeConfigurationContext<CloudFlowNodeType.CONDITION>();

  const {
    selectedNode,
    setSelectedNode,
    referenceableNodes,
    switchDataSourceOpen,
    handleConfirm,
    handleClose,
    confirmSwitchDataSource,
  } = useNodeDataSourceUpdate({
    nodeId: nodeConfig.id,
    referencedNodeId: nodeConfig.parameters.referencedNodeId,
  });

  return (
    <Stack
      sx={{
        px: 2,
        justifyContent: "center",
        gap: 2,
        mt: 1,
      }}
    >
      <Card sx={{ "&:hover": { borderColor: primary.main } }}>
        <NodeCardHeader
          avatar={<ForkRightRoundedIcon color="primary" />}
          subheader={cloudflowTexts.CONDITION_PANEL_SUBTITLE}
          title="IF statement"
        />
      </Card>
      <FieldReferenceForm
        selectedNode={selectedNode}
        confirmSwitchDataSource={confirmSwitchDataSource}
        setSelectedNode={setSelectedNode}
        referenceableNodes={referenceableNodes}
        texts={{
          referenceField: {
            title: cloudflowTexts.SELECT_DATA_TO_OUTPUT,
            subtitle: cloudflowTexts.DATA_WILL_BE_PASSED_DOWN_THE_FLOW,
          },
        }}
      />
      <ConditionForm
        selectedNode={selectedNode}
        referenceableNodes={referenceableNodes}
        texts={{
          addNewGroupText: cloudflowTexts.ADD_NEW_CONDITION_GROUP,
          defineCriteriaText: cloudflowTexts.DEFINE_CONDITION_CRITERIA,
          fromChosenFieldText: cloudflowTexts.DEFINE_TRUE_PATH_CRITERIA_DESCRIPTION,
          groupText: cloudflowTexts.CONDITION_GROUP,
          addNewText: cloudflowTexts.ADD_NEW_CONDITION,
        }}
      />
      <SwitchDataSourceDialog
        isDialogOpened={switchDataSourceOpen}
        handleClose={handleClose}
        handleConfirm={handleConfirm}
      />
    </Stack>
  );
};
